import {BBModel} from "../bb_model";
import {reasonTypeCodes} from '../constants/reason_type_codes';

class ReasonService {

    constructor() {
        'ngInject';
    }

    filterReasons(reasonItems, type) {
        if (!Object.values(reasonTypeCodes).includes(type)) {
            console.warn(`Reason type is not valid. Type must be one of: ${Object.keys(reasonTypeCodes).join(', ')}`);
            return;
        }
        const reasons = reasonItems.filter(reason => reason.reason_type === type);
        if (!reasons.length) {
            const reasonKey = Object.keys(reasonTypeCodes).find(key => reasonTypeCodes[key] === type);
            console.warn(`${reasonKey} ${ReasonService.REASONS_NOT_CONFIGURED_MSG}`);
        }
        return reasons;
    }

    getReasonsPromise(company, type) {

        return new Promise((resolve, reject) => {
            company.$get('reasons', { no_cache: true })
                .then((reasonsRaw) => {
                    reasonsRaw.$get('reasons')
                        .then((reasons) => {
                            reasons = reasons.map((reason) => {
                                if (reason instanceof BBModel.Reason) return reason;
                                return new BBModel.Reason(reason);
                            });
                            resolve(this.filterReasons(reasons, type));
                        });
                })
                .catch(error => reject(error));
        });
    }

    query(params) {
        return new Promise((resolve, reject) => {
            const { company, type } = params;

            if (!company.$has('reasons') && !company.$has('parent')) {
                reject(ReasonService.REASONS_DISABLED_MSG);
            }

            /*
                reasons can be turned on at parent or child level
                reasons are CONFIGURED at the parent level
                it is an oversight that they can be turned on at both levels as they can not be made at the child level
             */
            if (company.$has('parent')) {
                company.$getParent()
                    .then((parentCompany) => {
                        if (parentCompany.$has('reasons')) {
                            resolve(this.getReasonsPromise(parentCompany, type));
                        } else {
                            reject(ReasonService.REASONS_DISABLED_MSG);
                        }
                    });

            } else {
                if (company.$has('reasons')) {
                    resolve(this.getReasonsPromise(company, type));
                } else {
                    reject(ReasonService.REASONS_DISABLED_MSG);
                }
            }

        });
    }

}

ReasonService.REASONS_DISABLED_MSG = 'Reasons are not enabled for this company.';
ReasonService.REASONS_NOT_CONFIGURED_MSG = 'Reasons are not configured for this company.';

const reason = new ReasonService();

export {
    reason
}
